import Image from 'next/image';
import { DataTestConfig } from '@headless-workspace/config';
import { Component, ImageWithSrc } from '@headless-workspace/typings';
import { GlowClickable, GlowImage, GlowTextBody } from '../../../../src';

type GlowReinsuranceListItemProps = {
    image: ImageWithSrc;
    title: string;
    description: string;
    indexItem: number;
    cta: {
        href: string;
        label: string;
    };
};

const IMAGE_SIZE = 32;

export const GlowReinsuranceListItem: Component<GlowReinsuranceListItemProps> = ({
    image,
    title,
    description,
    cta,
    indexItem,
}) => {
    return (
        <li
            className={'flex flex-row gap-0.5 w-full'}
            data-testid={`${DataTestConfig.testIds.reinsuranceSection}${indexItem + 1}`}
        >
            <span className={'p-0.375'}>
                <GlowImage
                    image={image}
                    loading={'lazy'}
                    className={'min-h-iconLarge min-w-iconLarge'}
                    width={IMAGE_SIZE}
                    height={IMAGE_SIZE}
                    TagName={Image}
                />
            </span>
            <div className={'flex flex-col gap-0.5'}>
                <div>
                    <GlowTextBody text={title} fontWeight={'bold'} className={'line-clamp-1'} />
                    <GlowTextBody text={description} className={'line-clamp-2'} />
                </div>

                <GlowClickable
                    href={cta.href}
                    dataTestId={`${DataTestConfig.testIds.reinsuranceSectionLink}${indexItem + 1}`}
                    content={{
                        labelElement: (
                            <GlowTextBody text={cta.label} textDecoration={'underline'} className={'line-clamp-2'} />
                        ),
                    }}
                />
            </div>
        </li>
    );
};
